module.exports = __webpack_public_path__ + "static/media/title_window.5b026b7a.jpeg";